/* eslint-disable */
import React from 'react';

// Material-UI Components
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { TFunction } from 'i18next';

import {
  FilterFn,
  ISelectFilter,
} from '@/@types/ui/Table';

// Types
import { PickerItem } from '@/@types/controls/controls';
import { IPickerItems, PickerItemValue } from '@/@types/models/model';

/**
 * Filter wrapper function that returns the AutocompleteColumnFilter component
 *
 * @param {IPickerItems} fieldItems - picker items
 * @param {TFunction} t - translation function
 *
 * @returns The AutocompleteColumnFilter component
 */

export const FILE_FILTER_VALUES = {
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS',
} as const;

const FileColumnFilter  = (
  fieldItems : IPickerItems,
  t : TFunction 
) => {
const AutocompleteFn: FilterFn<ISelectFilter> = (filter) => {
  const { column } = filter;
  const { id, filterValue, setFilter, preFilteredRows } = column;

  const handleChange = (event: any, newValue: PickerItem | null) => {
    setFilter(newValue ? newValue.value : undefined);
  };

  const options = (() => {
    const optionSet = new Set<PickerItem>();

    if (fieldItems) {
      fieldItems.labels.forEach((label, i) => {
        const valueIteration = fieldItems.values[i];
        optionSet.add({
          value: valueIteration,
          label,
        });
      })
    }

    return Array.from(optionSet);
  })();

    return (
      <Autocomplete
        noOptionsText={t("core:common.no_options")}
        options={options}
        getOptionLabel={(option) => t(option.label)}
        value={options.find((opt) => opt.value === filterValue) || null}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
          />
        )}
        isOptionEqualToValue={(option, value) => option.value === value.value}
      />
    );
  };

  return AutocompleteFn;
};

export default FileColumnFilter;
